// extracted by mini-css-extract-plugin
export default {"productCarousel":"a0-z"};